import { faPhoneHangup } from '@fortawesome/pro-solid-svg-icons';
import { twMerge } from 'tailwind-merge';

import { Button, ButtonProps, IconButton } from '@growtherapy/sprout-ui';

// FIXME: TREE-1167
const DARK_OVERLAY_PARITY_CLASSES = [
  'arc:bg-transparent arc:text-[#ff7159] arc:border-[#ff7159]',
  'arc:hover:bg-[#1e100c] arc:hover:text-[#ff7159] arc:hover:border-[#ff7159]',
  'arc:active:bg-[#49221a] arc:active:text-[#ff7159] arc:active:border-[#e35541]',
].join(' ');

export function EndSessionButton({
  children,
  className,
  ...props
}: ButtonProps & {
  'aria-label': string;
}) {
  return (
    <>
      <IconButton
        id='end-session-button-mobile'
        className={twMerge(
          'md:hidden min-w-12 max-w-12 min-h-12 max-h-12 justify-center p-0',
          DARK_OVERLAY_PARITY_CLASSES,
        )}
        use='destructive'
        iconDefinition={faPhoneHangup}
        {...props}
      />
      <Button
        id='end-session-button'
        use='destructive'
        {...props}
        className={twMerge('hidden md:inline-flex items-center justify-center', DARK_OVERLAY_PARITY_CLASSES, className)}
      >
        {children}
      </Button>
    </>
  );
}
